module.exports = __webpack_public_path__ + "img/lianxi.68b8b778.png";